import './scss/index.scss';
import PlayerSuggestion from './js/player-suggestion';
import CountrySuggestion from './js/country-suggestion';

export {
    PlayerSuggestion,
    CountrySuggestion
};
